import { Region } from './region';

interface EventTablePosition {
  name: string;
  class: string;
}

export interface ColorPallet {
  name: string;
  colors: string[];
}

export class Settings {

  static tableLocations: EventTablePosition[] = [
    {
      name: 'Bottom',
      class: 'list-bottom'
    },
    {
      name: 'Top',
      class: 'list-top'
    },
  ];

  static baseMapEffects = ['none', 'grayscale', 'sepia'];
  static baseMaps = ['base', 'light'];

  static colorPalets: ColorPallet[] = [
    {
      name: 'Default',
      colors: ['#8bc34a', '#ffa500', '#ffff00', '#00ffff', '#e60ae6']
    },
    {
      name: 'Color Blind Friendly',
      colors: ['#009e73', '#d55e00', '#f0e442', '#0072b2', '#cc79a7']
    },
  ]

  static languages = ['sr', 'en', 'es'];
  static sources = ['iris', 'usgs'];

  dataFetchInterval: number;
  smartRegion: boolean; // Don't show the region if no events in in
  cycleTablePosition: boolean; // Don't show the region if no events in in
  colorPalletIndex: number;
  tablePosition: string;
  baseMapEffect: string;
  baseMap: string;
  language: string;
  dateType: 'absolute' | 'relative';
  regions: Region[];
  animateHowMany: number;
  source: 'iris' | 'usgs';

  nextTablePosition(): EventTablePosition {
    let index = Settings.tableLocations.findIndex(post => post.class === this.tablePosition);
    index = index === -1 ? 0 : index;
    index = index + 1 >= Settings.tableLocations.length ? 0 : index + 1;
    return Settings.tableLocations[index];
  }

  getColorPallet(index = this.colorPalletIndex): ColorPallet {
    return Settings.colorPalets[index];
  }

  getColor(index: number): string {
    const activeColorPallet = this.getColorPallet();
    return activeColorPallet.colors[index];
  }
}
